import React from 'react';
import ProductList from '../../Product/List';

/**
 * 员工和管理员后台产品列表页
 * 
 * 按照"统一组件+角色权限控制"开发规范：
 * - 直接复用客户后台的产品列表主组件
 * - 通过 useAuth 自动判断角色权限
 * - 样式和布局完全一致
 * - 零代码重复，100%复用
 */
const AdminStaffProductList: React.FC = () => {
  // 直接使用客户后台的产品列表组件
  // 通过 useAuth 自动判断角色权限，动态显示不同的列和操作
  return <ProductList />;
};

export default AdminStaffProductList; 